import React from 'react';
import { modelClass } from '/imports/api/cardSources';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { useUser } from '/imports/hooks';

export const CardSourcesPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[{ field: 'windowsroot', label: 'Windows Root' }, { field: 'clientpath', label: 'Client Path' }]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
